/* LuminLab Haut-Quiz: Grafiken für alle Antworten */
(function () {
  var FACE = 'M32 7c11 0 19 9.5 19 23 0 14.5-8.5 27-19 27S13 44.5 13 30C13 16.5 21 7 32 7z';
  var S = ' fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"';
  function svg(inner) {
    return '<svg class="llq__svg" viewBox="0 0 64 64" aria-hidden="true" focusable="false">' + inner + '</svg>';
  }
  function face(inner, opts) {
    opts = opts || {};
    var mouth = opts.frown ? 'M28.5 46c2-1.6 5-1.6 7 0' : 'M28.5 44c2 1.6 5 1.6 7 0';
    return svg((opts.full ? '<path d="' + FACE + '" fill="currentColor" opacity=".16"/>' : '') + inner +
      '<path d="' + FACE + '"' + S + '/>' +
      '<path d="M25 27.5h4.5M34.5 27.5H39M' + mouth.slice(1) + '"' + S + ' stroke-width="1.4"/>');
  }
  function cheeks(op) {
    return '<circle cx="21.5" cy="37" r="4.6" fill="currentColor" opacity="' + op + '"/><circle cx="42.5" cy="37" r="4.6" fill="currentColor" opacity="' + op + '"/>';
  }
  function spots(list, r, op) {
    return list.map(function (d) { return '<circle cx="' + d[0] + '" cy="' + d[1] + '" r="' + r + '" fill="currentColor" opacity="' + op + '"/>'; }).join('');
  }
  function rings(list) {
    return list.map(function (d) { return '<circle cx="' + d[0] + '" cy="' + d[1] + '" r="3"' + S + ' stroke-width="1" opacity=".55"/>'; }).join('');
  }
  var ZAP = '<path d="M9 30l3 2.5-3 2.5 3 2.5M55 30l-3 2.5 3 2.5-3 2.5"' + S + ' stroke-width="1.3"/>';
  var CHECK = '<circle cx="50" cy="13" r="7" fill="currentColor" opacity=".16"/><path d="M46.8 13.2l2.2 2.2 4.2-4.6"' + S + '/>';
  var LINES = '<path d="M25 17.5c4.5-1.6 9.5-1.6 14 0M26.5 21.5c3.6-1.1 7.4-1.1 11 0M20 25.5l-2.5-1.5M20 29.5l-2.8.4M44 25.5l2.5-1.5M44 29.5l2.8.4"' + S + ' stroke-width="1.2"/>';

  var DROP = svg('<path d="M32 9C24 20 18 29 18 37a14 14 0 0028 0c0-8-6-17-14-28z" fill="currentColor" opacity=".16"/>' +
    '<path d="M32 9C24 20 18 29 18 37a14 14 0 0028 0c0-8-6-17-14-28z"' + S + '/>' +
    '<path d="M25 38a7 7 0 006 7"' + S + '/>');
  var SUN = svg('<circle cx="32" cy="32" r="10" fill="currentColor" opacity=".16"/><circle cx="32" cy="32" r="10"' + S + '/>' +
    '<path d="M32 10v6M32 48v6M10 32h6M48 32h6M16.4 16.4l4.3 4.3M43.3 43.3l4.3 4.3M16.4 47.6l4.3-4.3M43.3 20.7l4.3-4.3"' + S + '/>');
  var FOAM = svg('<path d="M24 26h16v26a3 3 0 01-3 3H27a3 3 0 01-3-3z" fill="currentColor" opacity=".16"/>' +
    '<path d="M24 26h16v26a3 3 0 01-3 3H27a3 3 0 01-3-3zM27 26v-5h10v5M32 21v-5h7M28 37h8"' + S + '/>' +
    '<circle cx="45" cy="15" r="3"' + S + ' stroke-width="1.2"/><circle cx="50" cy="22" r="2"' + S + ' stroke-width="1.2"/><circle cx="44" cy="23" r="1.4" fill="currentColor"/>');
  var TONER = svg('<path d="M23 24h18v28a3 3 0 01-3 3H26a3 3 0 01-3-3z" fill="currentColor" opacity=".16"/>' +
    '<path d="M23 24h18v28a3 3 0 01-3 3H26a3 3 0 01-3-3zM26 24l2-5h8l2 5M28 19v-5h8v5M28 36h8M28 40h5"' + S + '/>');
  var SERUM = svg('<path d="M24 32h16v19a4 4 0 01-4 4h-8a4 4 0 01-4-4z" fill="currentColor" opacity=".16"/>' +
    '<path d="M24 32h16v19a4 4 0 01-4 4h-8a4 4 0 01-4-4zM27 32v-4h10v4M29 28V17M35 28V17M29 17a3 3 0 016 0z"' + S + '/>' +
    '<path d="M32 40c-1.6 2.3-2.4 3.6-2.4 4.6a2.4 2.4 0 004.8 0c0-1-.8-2.3-2.4-4.6z" fill="currentColor"/>');
  var JAR = svg('<path d="M16 34h32v14a6 6 0 01-6 6H22a6 6 0 01-6-6z" fill="currentColor" opacity=".16"/>' +
    '<path d="M16 34h32v14a6 6 0 01-6 6H22a6 6 0 01-6-6zM15 27h34v7H15zM24 44h16"' + S + '/>' +
    '<path d="M27 21c2-3 8-3 10 0"' + S + ' stroke-width="1.2"/>');
  var SPROUT = svg('<path d="M32 54V32"' + S + '/>' +
    '<path d="M32 36c-9 0-14-5-14-13 9 0 14 5 14 13zM32 31c0-8 5-13 14-13 0 8-5 13-14 13z" fill="currentColor" opacity=".16"/>' +
    '<path d="M32 36c-9 0-14-5-14-13 9 0 14 5 14 13zM32 31c0-8 5-13 14-13 0 8-5 13-14 13zM22 54h20"' + S + '/>');
  var LEAF = svg('<path d="M16 48C16 26 30 14 50 14c0 22-12 34-30 34z" fill="currentColor" opacity=".16"/>' +
    '<path d="M16 48C16 26 30 14 50 14c0 22-12 34-30 34zM16 48l20-20"' + S + '/>');
  var NIGHT = svg('<path d="M22 34h14v17a4 4 0 01-4 4h-6a4 4 0 01-4-4z" fill="currentColor" opacity=".16"/>' +
    '<path d="M22 34h14v17a4 4 0 01-4 4h-6a4 4 0 01-4-4zM25 34v-4h8v4M27 30V20M31 30V20M27 20a2 2 0 014 0z"' + S + '/>' +
    '<path d="M50 12a9 9 0 1 0 2 15 7 7 0 0 1-2-15z" fill="currentColor" opacity=".16"/><path d="M50 12a9 9 0 1 0 2 15 7 7 0 0 1-2-15z"' + S + '/>');
  function steps(n) {
    var w = 44, x0 = 10, gap = w / (n - 1), out = '<path d="M' + x0 + ' 32h' + w + '"' + S + ' stroke-width="1.2" opacity=".45"/>';
    for (var i = 0; i < n; i++) {
      var x = (x0 + gap * i).toFixed(1);
      out += '<circle cx="' + x + '" cy="32" r="' + (n > 5 ? 3.2 : 4.2) + '" fill="currentColor"' + (i ? ' opacity=".85"' : '') + '/>';
    }
    out += '<text x="32" y="52" text-anchor="middle" font-size="11" font-family="inherit" fill="currentColor">' + n + (n === 7 ? '+' : '') + '</text>';
    return svg(out);
  }

  var ICONS = {
    sens: {
      yes: face(cheeks('.38') + ZAP, { frown: true }),
      some: face(cheeks('.18')),
      no: face(CHECK)
    },
    concerns: {
      'unreinheiten': face(spots([[22, 35], [41, 38], [36, 18], [44, 31]], 1.6, '.9')),
      'roetungen': face(cheeks('.38')),
      'pigmentflecken': face(spots([[22, 34], [25.5, 38], [42, 36], [37, 17]], 2.2, '.42')),
      'feuchtigkeit': DROP,
      'anti-aging': face(LINES)
    },
    blemish: {
      rare: face(spots([[42, 37]], 1.7, '.9')),
      often: face(spots([[22, 35], [42, 37], [36, 18], [26, 40]], 1.6, '.9')),
      always: face(spots([[21, 34], [25, 39], [42, 34], [44, 39], [38, 40], [36, 18], [28, 16], [32, 50]], 1.5, '.9') + rings([[23, 36.5], [43, 36.5]]))
    },
    current: { clean: FOAM, toner: TONER, serum: SERUM, cream: JAR, spf: SUN, none: SPROUT },
    retinal: { yes: NIGHT, no: LEAF },
    steps: { minimal: steps(3), classic: steps(5), full: steps(7) }
  };


  /* 10 % auf die ganze 7+ Routine */
  var CODE = 'ROUTINE7';
  var EN = /^en/i.test(document.documentElement.lang || '');
  var T = EN ? {
    badge: '−10 %',
    title: 'Your bonus: 10 % off',
    text: 'Add the whole routine to your cart and we take 10 % off automatically.',
    btn: 'Add the whole routine with 10 % off',
    ok: '10 % discount applied'
  } : {
    badge: '−10 %',
    title: 'Dein Vorteil: 10 % Rabatt',
    text: 'Lege die ganze Routine in den Warenkorb, dann ziehen wir automatisch 10 % ab.',
    btn: 'Ganze Routine mit 10 % in den Warenkorb',
    ok: '10 % Rabatt ist im Warenkorb aktiv'
  };
  var choice = null;
  var wantDiscount = false;
  function rootUrl() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function isOffer(screen) { return choice === 'full' && (screen || document).querySelectorAll('.llq__steps .llq__step').length >= 7; }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var opt = e.target.closest('.llq__opt');
    if (opt && /^(minimal|classic|full)$/.test(opt.getAttribute('data-value') || '')) choice = opt.getAttribute('data-value');
    if (e.target.closest('[data-ll-add-all]') && isOffer()) wantDiscount = true;
  }, true);
  document.addEventListener('cart:update', function (e) {
    var d = e.detail || {};
    if (!wantDiscount || d.sourceId !== 'luminlab-quiz') return;
    wantDiscount = false;
    fetch(rootUrl() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: CODE })
    })
      .then(function (r) { if (!r.ok) throw new Error('discount'); return r.json(); })
      .catch(function () { return fetch(rootUrl() + 'discount/' + CODE).then(function () { return fetch(rootUrl() + 'cart.js'); }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'luminlab-quiz-discount', data: { source: 'luminlab-quiz-discount', itemCount: cart.item_count } } }));
        var note = document.querySelector('.llq [data-ll-added]');
        if (note) { note.hidden = false; note.insertAdjacentHTML('beforeend', ' · <strong>' + T.ok + ' ✓</strong>'); }
      })
      .catch(function () {});
  });
  function decorateOffer(screen) {
    var full = screen.querySelector('.llq__opt[data-value="full"] .llq__opt-label');
    if (full && !full.querySelector('.llq__badge')) full.insertAdjacentHTML('beforeend', '<span class="llq__badge">' + T.badge + '</span>');
    var total = screen.querySelector('.llq__total');
    if (total && isOffer(screen) && !screen.querySelector('.llq-offer')) {
      total.insertAdjacentHTML('beforebegin', '<div class="llq-offer"><strong>' + T.title + '</strong><span>' + T.text + '</span></div>');
      var btn = total.querySelector('[data-ll-add-all]');
      if (btn) btn.textContent = T.btn;
    }
  }

  function keyFor(values) {
    if (values.indexOf('some') > -1) return 'sens';
    if (values.indexOf('unreinheiten') > -1) return 'concerns';
    if (values.indexOf('rare') > -1) return 'blemish';
    if (values.indexOf('clean') > -1) return 'current';
    if (values.indexOf('minimal') > -1) return 'steps';
    if (values.length === 2 && values.indexOf('yes') > -1 && values.indexOf('no') > -1) return 'retinal';
    return null;
  }

  function decorate(screen) {
    var groups = screen.querySelectorAll('.llq__options:not(.llq__options--icons)');
    Array.prototype.forEach.call(groups, function (group) {
      var btns = group.querySelectorAll('.llq__opt');
      var values = Array.prototype.map.call(btns, function (b) { return b.getAttribute('data-value'); });
      var key = keyFor(values);
      if (!key) return;
      group.classList.remove('llq__options--grid');
      group.classList.add('llq__options--icons');
      if (btns.length === 6) group.classList.add('llq-six');
      Array.prototype.forEach.call(btns, function (b) {
        var icon = ICONS[key][b.getAttribute('data-value')];
        if (!icon || b.querySelector('.llq__icon')) return;
        b.classList.add('llq__opt--icon');
        var span = document.createElement('span');
        span.className = 'llq__icon';
        span.innerHTML = icon;
        b.insertBefore(span, b.firstChild);
      });
    });
    decorateOffer(screen);
  }

  function init() {
    var st = document.createElement('style');
    st.textContent = '@media screen and (min-width:750px){.llq .llq__options--icons.llq-six{grid-template-columns:repeat(3,minmax(0,1fr))}}' +
      '.llq-offer{display:flex;flex-direction:column;gap:4px;padding:18px 22px;background:#111;color:#FAF8F5;margin-bottom:-36px}.llq-offer strong{font-weight:500;font-size:1.05rem}.llq-offer span{font-size:.875rem;opacity:.8}';
    document.head.appendChild(st);
    var screens = document.querySelectorAll('.llq [data-ll-screen]');
    Array.prototype.forEach.call(screens, function (screen) {
      decorate(screen);
      new MutationObserver(function () { decorate(screen); }).observe(screen, { childList: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();